const course = {
  state: {
    id:0,
    pushStatus:0,
    basicMessageFirst: [], // 步骤1的第一部分填写的信息
    basicMessageSecond: [], // 步骤1的第二部分填写的信息
    courseChapter: [], // 步骤2的课件的章节
    courseQuizQuestion: [], // 步骤2的课件的题目
    pushRange: [] // 步骤3的发布的范围
  },
  getters: {
    id: state => {
      return state.id
    },
    pushStatus: state => {
      return state.pushStatus
    },
    basicMessageFirst: state => {
      return state.basicMessageFirst
    },
    basicMessageSecond: state => {
      return state.basicMessageSecond
    },
    courseChapter: state => {
      return state.courseChapter
    },
    courseQuizQuestion: state => {
      return state.courseQuizQuestion
    },
    pushRange: state => {
      return state.pushRange
    }
  },
  mutations: {
    SET_COURSE_ID(state, id) {
      state.id = id
    },
    SET_PushStatus(state, pushStatus) {
      state.pushStatus = pushStatus
    },
    SET_BASICMESSAGE_FIRST(state, basicMessageFirst) {
      state.basicMessageFirst = basicMessageFirst
    },
    SET_BASICMESSAGE_SECOND(state, basicMessageSecond) {
      state.basicMessageSecond = basicMessageSecond
    },
    SET_COURSE_CHAPTER (state, courseChapter) {
      state.courseChapter = courseChapter
    },
    SET_COURSE_QUIZ_QUESTION (state, courseQuizQuestion) {
      state.courseQuizQuestion = courseQuizQuestion
    },
    SET_PUSHRANGE (state, pushRange) {
      state.pushRange = pushRange
    }
  },
  actions: {}
}

export default course



// WEBPACK FOOTER //
// ./src/store/modules/course.js